import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { useMutation } from "@apollo/client";

import loadIcon from "../../../assets/images/tail-spin.svg";

import ModalHolder from "../../molecules/ModalHolder";

import {
  MODIFY_MEMBER_ROLE_MUTATION,
  REMOVE_TEAM_MEMBER_MUTATION,
} from "../../../shared/queries";
import { toastError, toastSuccess } from "../../../shared/helpers";
import { DarkSelectInput } from "../../atoms/Inputs";
import { P } from "../../atoms/Texts";
import { PrimaryButton } from "../../atoms/Buttons";
import useTeamMembers from "../../../shared/hooks/useTeamMembers";
import { useParams } from "react-router-dom";

const EditMemberModal = ({ closeModal, member }) => {
  const { id } = useParams();

  const { getAllTeamMembers } = useTeamMembers();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [loading, setLoading] = useState(false);

  // Save A Organization Mutation

  const [editMember] = useMutation(MODIFY_MEMBER_ROLE_MUTATION);

  const onEditMember = (data) => {
    setLoading(true);

    editMember({
      variables: {
        modifyMemberRoleData: {
          role: data.role,
          userId: member.userId,
          organizationId: id,
        },
      },
    })
      .then(() => {
        window.location.reload();
        toastSuccess("Member Edited successfully.");
        setLoading(false);
        closeModal();
      })
      .catch((error) => {
        setLoading(false);
        toastError(error.message);
      });
  };

  const [removeMember, { loading: deleting }] = useMutation(
    REMOVE_TEAM_MEMBER_MUTATION,
  );

  const onRemoveMember = () => {
    removeMember({
      variables: {
        removeTeamMemberData: {
          userId: member.userId,
          organizationId: id,
        },
      },
    })
      .then(() => {
        window.location.reload();
        toastSuccess("Member removed successfully.");
        getAllTeamMembers(id);
        closeModal();
      })
      .catch((error) => {
        toastError(error.message);
      });
  };

  return (
    <ModalHolder closeModal={closeModal} header="Edit Member">
      <form onSubmit={handleSubmit(onEditMember)} className="pt-10 pb-12">
        <div>
          <DarkSelectInput
            type="select"
            id="role"
            name="role"
            className="py-1 px-2"
            label="User Level"
            defaultValue={member?.role}
            iconBeforeClass=""
            inputClassName="-ml-3"
            {...register("role", {
              required: "Select role for member",
            })}
          >
            <option value="" disabled>
              --Set role--
            </option>
            <option value="user">User</option>
            <option value="admin">Admin</option>
            <option value="reader">Reader</option>
          </DarkSelectInput>
          <ErrorMessage
            errors={errors}
            name="role"
            as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
          >
            {({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <P key={type}>{message}</P>
              ))
            }
          </ErrorMessage>
        </div>

        <div className="flex">
          <PrimaryButton className="w-full" disabled={loading}>
            {!loading ? (
              "Submit"
            ) : (
              <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
            )}
          </PrimaryButton>
        </div>
        <div className="flex mt-4">
          <PrimaryButton.Danger
            type="button"
            onClick={onRemoveMember}
            className="w-full"
            disabled={deleting}
          >
            {!deleting ? (
              "Remove Member"
            ) : (
              <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
            )}
          </PrimaryButton.Danger>
        </div>
      </form>
    </ModalHolder>
  );
};

export default EditMemberModal;
